/** @jsx jsx */
import React from 'react'
import { jsx } from '@emotion/core'
import { observer } from 'mobx-react'
import _ from 'lodash'
import useRootStore from '@store/useRootStore'
import { EMPTY_ICON } from '@constants/index'
import { AdvEmpty } from '@components/AdvEmpty'
import StatVisualization from '@components/IframeWrapper/StatVisualization'
import { DetailMatchTrack, MatchTrack } from '@store/matchupStore'
import classNames from 'classnames'
import { SPORT_ID } from 'adv-protocol/src/GameCommon'

export const StatVisualizationWrapper: React.FC = observer(props => {
  const { globalStore, matchupStore } = useRootStore()
  const {
    detailTrack,
  } = matchupStore

  const {
    sportId = 178,
  } = detailTrack || ({} as DetailMatchTrack)

  const {
    matchId,
    seasonId,
    homeTeamId,
    awayTeamId,
  } = detailTrack?.track ?? ({} as MatchTrack)

  const isSupportStatVisualization = (seasonId: number, homeTeamId: number, awayTeamId: number): boolean => {
    return [seasonId, homeTeamId, awayTeamId].every(id => !_.isNil(id))
  }

  const statVisualizationClassName = classNames('',
    { 'large': sportId === SPORT_ID.SOCCER }, // iframe의 컨텐츠가 긴 종목 스타일(축구)
  )

  return isSupportStatVisualization(seasonId, homeTeamId, awayTeamId) ?
    <StatVisualization
      url={globalStore.getStatVisualizationUrl(matchId, sportId, seasonId, homeTeamId, awayTeamId)}
      className={statVisualizationClassName}
    />
    :
    <div css={{ position: 'relative', paddingBottom: 'calc(63px + 60px)' }}>
        <AdvEmpty ico={EMPTY_ICON.VISUALIZATION}/>
    </div>
})
